import { useTranslations } from "next-intl";

import { FormControl, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";

interface ISignatureProps extends React.ComponentProps<"input"> {
    loading: boolean;
    isPending: boolean;
}

export const Signature = ({ isPending, loading, ...props }: ISignatureProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("signature")} :</FormLabel>
            <FormControl className="w-full md:w-1/2">
                {loading ? (
                    <Skeleton className="h-[36px] w-full" />
                ) : (
                    <Input { ...props } disabled={ isPending } />
                )}
            </FormControl>
            <FormMessage />
        </FormItem>
    );
};